// packages
import { json } from 'd3-fetch';

// components
import NationalStaticEmbed from './components/NationalStaticEmbed.svelte';

// stores
import { createNationalStore } from './stores/national';

// utils
import { getGeographyUrl } from './constants';
import { getGeoJsonFromTopoJson } from './utils/topojson-to-geojson';

// types
import type { Topology } from 'topojson-specification';

async function main() {
  const topology = (await json(getGeographyUrl('us', 'countries'))) as Topology;

  const geography = getGeoJsonFromTopoJson(topology, 'states', true);

  const store = await createNationalStore();

  new NationalStaticEmbed({
    target: document.getElementById('embed') as HTMLElement,
    props: { geography, store },
  });
}

main().catch(console.error);
